module.exports = __webpack_public_path__ + "img/bgr-blocks.f55000ec.svg";